@if (authenticationError) {
  <div class="authentication-state" role="alert">
    <p>{{ authenticationError }}</p>
    <button type="button" (click)="login()">Try again</button>
  </div>
} @else if (isSignedOut) {
  <div class="authentication-state">
    <p>You have been signed out.</p>
    <button type="button" (click)="login()">Sign in</button>
  </div>
} @else if (isAuthorized | async) {
  <div>
    <mat-toolbar color="primary">
      <div class="toolbar-spacer"></div>
    </mat-toolbar>
    <div>
      <toolbar></toolbar>
      <div class="container">
        <sidebar>
        </sidebar>
      </div>
    </div>
  </div>
}
